import React from "react";
import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  Selection
} from "devextreme-react/data-grid";
import { withStyles } from "@material-ui/core/styles";
import { columns } from "./utils";
import Buttons from "../../../../../Groups/pages/GroupView/components/Students/RequestPersonTable/Cells/Buttons";
import ButtonsCell from "./ButtonsCell";
import LinkIcon from "@material-ui/icons/Link";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "300px"
    }
  }
};

class RelationStudentsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedStudents: [],
      focusedStudent: -1,
      focusedRowIndex: -1
    };

    this.selectStudents = this.selectStudents.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.dataGridRef = React.createRef();
  }

  selectStudents({ selectedRowsData }) {
    this.setState({ selectedStudents: selectedRowsData });
  }

  onRowClick(e) {
    const focusedStudent = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedStudent, focusedRowIndex });
  }

  render() {
    const {
      selectedStudents,
      focusedRowIndex,
      focusedStudent
    } = this.state;

    const {
      relStudentList,
      setRequestStudent,
      requestId,
      classes
    } = this.props;
    const { root } = classes;

    return (
      <div className={root}>
        <DataGrid
          elementAttr={{
            id: "gridContainer"
          }}
          ref={this.dataGridRef}
          wordWrapEnabled={true}
          dataSource={relStudentList}
          onSelectionChanged={this.selectStudents}
          focusedRowEnabled
          errorRowEnabled={false}
          onRowClick={this.onRowClick}
          focusedRowIndex={focusedRowIndex}
          showBorders
        >
          <Selection mode="single" />
          {columns.map(column => (
            <Column key={column.dataField} {...column} />
          ))}
          <Column type="buttons" width={80}
                  buttons={[{
                    hint: 'Привязать аккаунт пользователя к заявке',
                    icon: 'link',
                    visible: true,
                    onClick: ()=>{
                      setRequestStudent && setRequestStudent(requestId, focusedStudent)
                  }}]} />
          <FilterRow visible={true} />
          <Scrolling mode="virtual" />
          <LoadPanel enabled/>
        </DataGrid>
      </div>
    );
  }
}

export default withStyles(styles)(RelationStudentsTable);
